import type { ChatMessageDto } from '@hv/shared';

export function rescoreLabel(was: number | null, now: number | null): string {
  if (now === null) return 'Score updated';
  if (was === null) return `Score updated to ${now}`;
  if (was === now) return `Rescored, score still ${now}`;
  return `Score updated to ${now} (was ${was})`;
}

export function rescoreDividers(messages: ChatMessageDto[]): Map<string, string> {
  const dividers = new Map<string, string>();
  let previous: ChatMessageDto | null = null;
  messages.forEach((m, i) => {
    if (m.role !== 'assistant') return;
    if (previous && previous.assessmentId !== m.assessmentId) {
      const question = messages[i - 1];
      const before = question?.role === 'user' ? question : m;
      dividers.set(before.id, rescoreLabel(previous.assessmentScore, m.assessmentScore));
    }
    previous = m;
  });
  return dividers;
}
